import { css } from 'styled-components';
import token from 'styled-token';
import { hoverMediaQueryMixin } from './hoverMediaQueryMixin';
var defaultCSS = function defaultCSS(props) {
  return token({
    backgroundColor: 'Radio.backgroundColor',
    borderColor: 'Radio.borderColor',
    borderColorHover: 'Radio.borderColorHover',
    borderColorDisabled: 'Radio.borderColorDisabled',
    borderRadius: 'radii.ellipse',
    borderWidth: 'Radio.borderWidth',
    focusBoxShadow: 'shadows.focus',
    size: 'Radio.size'
  }, function (tokens) {
    return css(["appearance:none;outline:none;box-shadow:none;box-sizing:border-box;display:inline-block;height:", "px;width:", "px;background:", ";border:", "px solid ", ";border-radius:", ";cursor:pointer;margin:0;transition:border-color 200ms ease-in-out,background-color 200ms ease-in-out;"], tokens.size, tokens.size, tokens.backgroundColor, tokens.borderWidth, props.disabled || props['aria-disabled'] ? tokens.borderColorDisabled : tokens.borderColor, tokens.borderRadius);
  })(props);
};
var hoverCSS = function hoverCSS(props) {
  return token({
    borderColorHover: 'Radio.borderColorHover'
  }, function (tokens) {
    return css(["border-color:", ";"], tokens.borderColorHover);
  })(props);
};
var pressedCSS = function pressedCSS(props) {
  return token({
    borderColorPressed: 'Radio.borderColorPressed'
  }, function (tokens) {
    return css(["border-color:", ";"], tokens.borderColorPressed);
  })(props);
};
var checkedCSS = function checkedCSS(props) {
  return token({
    borderColorActive: 'Radio.borderColorActive',
    borderColorActiveHover: 'Radio.borderColorActiveHover',
    borderColorActivePressed: 'Radio.borderColorActivePressed',
    borderWidth: 'Radio.borderWidthChecked'
  }, function (tokens) {
    return css(["border-color:", ";border-width:", "px;", ";&:active:not(:disabled){border-color:", ";}"], tokens.borderColorActive, tokens.borderWidth, hoverMediaQueryMixin("\n        border-color: " + tokens.borderColorActiveHover + ";\n      "), tokens.borderColorActivePressed);
  })(props);
};
var focusCSS = function focusCSS(props) {
  return token({
    boxShadow: 'shadows.focus'
  }, function (tokens) {
    return css(["box-shadow:", ";"], tokens.boxShadow);
  })(props);
};

/** @mixin radioStateMixin */
/** @method */
export var radioStateMixin = function radioStateMixin(state) {
  return function (props) {
    switch (state) {
      case 'hover':
        return hoverCSS(props);
      case 'pressed':
        return pressedCSS(props);
      case 'checked':
        return checkedCSS(props);
      case 'focus':
        return focusCSS(props);
      default:
        return defaultCSS(props);
    }
  };
};